module.exports = __webpack_public_path__ + "static/media/versace.2c2f76db.jpg";